import { Box, Grid } from '@mui/material';
import TemplateOrganisationSearchableSelect from '../shared/TemplateOrganisationSearchableSelect';
import TemplateBotNumberSearchableSelect from '../shared/TemplateBotNumberSearchableSelect';
import RequiredLabel from '../ui/RequiredLabel';

export default function OrganisationBotFields({
  isSuperuser,
  organisation,
  botNumber,
  onOrganisationChange,
  onBotChange,
  errors = {},
  botDisabled = false,
  sx,
}) {
  return (
    <Box sx={sx}>
      <Grid container spacing={2}>
        {isSuperuser ? (
          <Grid item xs={12} md={6}>
            <TemplateOrganisationSearchableSelect
              label={<RequiredLabel>Select Organisation</RequiredLabel>}
              placeholder="Select Organisation"
              selectVariant="form"
              valueId={organisation?.organisation_id ?? organisation?.id ?? null}
              selectedOrganisation={organisation}
              onChange={onOrganisationChange}
              error={Boolean(errors.organisation)}
              helperText={errors.organisation}
            />
          </Grid>
        ) : null}

        <Grid item xs={12} md={isSuperuser ? 6 : 12}>
          <TemplateBotNumberSearchableSelect
            label={<RequiredLabel>Bot Number</RequiredLabel>}
            placeholder="Select Bot Number"
            selectVariant="form"
            organisation={organisation}
            valueId={botNumber?.wa_phone_number ?? botNumber?.value ?? null}
            selectedBot={botNumber}
            onChange={onBotChange}
            error={Boolean(errors.botNumber)}
            helperText={errors.botNumber}
            disabled={botDisabled}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
